/* Built In Imports */
/* External Imports */
import { Box } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';

/* Styles */
/* Services */

/**
 * Renders SadhguruSignatureLoveGrace Component
 *
 * @param {object} Card
 * @returns {ReactElement} SadhguruSignatureLoveGrace Component
 */

const SadhguruSignatureLoveGrace = ({ card }) => {
  return (
    <Box
      width={{ base: '100%', md: '288px' }}
      my="20px"
    >
      <Box fontSize="20px" mb="18px">
        {card?.text?.json?.text}
      </Box>
      {card?.text?.json?.signImageURL && (
        <LazyLoadImageComponent
          src={card?.text?.json?.signImageURL}
          alt="Sadhguru Signature"
          objectFit="cover"
        />
      )}
    </Box>
  );
};

export default SadhguruSignatureLoveGrace;
